import {
  ref,
  reactive,
  onBeforeMount,
  computed,
  watch,
} from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import useModal from "@/@core/components/base-modal/hooks/useModal";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import inventoryPrivilegeFormModel from "@/models/inventory/inventory-privilege-form";
import inventoryListModel from "@/models/inventory/inventory-list";
import usePagination from "@/views/components/pagination/usePagination";
import useFilterHeaderTable from "@/views/components/filter-header-table/useFilterHeaderTable";
import useDate from "@/utils/hooks/useDate";
import { PRIVILEGE_TYPE } from "@/configs/privilege/privilege";

export default function useInventoryManageCustom() {
  const { resolveDateWithSeperator } = useDate();
  const {
    inventoryPrivilegeFormDetail,
    inventoryPrivilegeFormEdit,
    fetchAssignEntryInventory,
  } = inventoryPrivilegeFormModel();
  const {
    fetchEntryInventoryList,
    fetchReorderList: fetchReorderPrivilegeList,
  } = inventoryListModel();
  const { openModal, closeModal } = useModal();
  const {
    openDefaultErrorModal,
    openErrorModal,
    openSuccessModal,
  } = useValidationModal();
  const { pagination, onPageChange, onFilterEntity } = usePagination();
  const {
    filters,
    ordering,
    onSetValueSearch,
    onSelectFilter,
  } = useFilterHeaderTable();
  const keyChange = ref(0);
  const currentIndex = ref(null);
  const currentIdSelect = ref(null);
  const tableModeReorder = ref(false);
  const isDisplayNonePayload = ref(true);
  const loading = reactive({
    tableData: false,
    formInventory: false,
    tableOverlay: false,
    addPrivilege: false,
  });

  const fields = [
    { key: "seq", label: "No." },
    { key: "expired_alert", label: "Expired Status" },
    { key: "stock_mode", label: "Stock Mode" },
    { key: "privilege.alt_reference", label: "Reference" },
    { key: "image_url", label: "Image" },
    { key: "nameTh", label: "Name" },
    { key: "privilege_type", label: "Reward Type" },
    { key: "remaining_qty", label: "Balance" },
    { key: "total_qty", label: "Total" },
    { key: "updatedtime", label: "Updated" },
    { key: "status", label: "Status" },
    { key: "actions", label: "" },
  ];

  const formInventory = reactive({
    reference: "",
    name: "",
    detail: "",
  });

  const formStatus = reactive({
    status: null,
    stockMode: null,
    statusExpired: null,
    expiredStatus: false
  });

  const inventoryManageActionList = reactive({
    settingManage: {
      label: "Manage Stock",
      value: 1,
      icon: "IconSettingManage",
      display: true,
    },
    transfer: {
      label: "Transfer",
      value: 2,
      icon: "IconTransfer",
      display: true,
    },
    history: {
      label: "History",
      value: 3,
      icon: "IconHistory",
      display: true,
    },
    detail: {
      label: "Import Detail",
      value: 4,
      icon: "IconImport",
      display: true,
    },
    stockDetail: {
      label: "Total Serial",
      value: 5,
      icon: "IconStockDetail",
      display: true,
    },
    reOrder: {
      label: "Reorder",
      value: 6,
      icon: "ReorderIcon",
      display: false,
    },
    // delete: {
    //   label: 'Delete',
    //   value: 7,
    //   icon: 'DeleteIcon',
    //   display: true,
    // },
  });

  const resolveMappingTableAction = (type, item) => {
    switch (type) {
      case 1:
        openManageStockModal(item.item.privilege);
        return;
      case 2:
        rewardSelect.value = item.item.privilege;
        modalType.transferStock = true;
        openModal();
        return;
      case 3:
        routeHistory(item.item);
        return;
      case 4:
        routeDetail(item.item);
        return;
      case 5:
        routeStockDetail(item.item);
        return;
      case 6:
        modalType.reorder = true;
        openReorderModal(item.item);
      default:
    }
  };

  const resolveExpiredAlertLabel = (type) => {
    switch (type) {
      case 1:
        return "โค้ดใกล้หมดอายุ";
      default:
        return "-";
    }
  }

  const resolveExpiredAlertClass = (type) => {
    switch (type) {
      case 1:
        return "Expired";
      default:
        return "";
    }
  }

  const statusOption = ref([
    { label: "Active", value: 1 },
    { label: "Inactive", value: 2 },
  ]);

  const stockModeOption = ref([
    { label: "None", value: 1 },
    { label: "Overselling", value: 2 },
    { label: "Restricted", value: 3 },
  ]);

  const inventoryManageTable = reactive({
    payload: [],
  });

  const rewardSelect = ref({});

  const modalType = reactive({
    reorder: false,
    addPrivilege: false,
    transferStock: false,
    manageStockReward: false,
    manageStockCouponExternal: false,
    transferStockForm: false,
  });

  const routeHistory = (item) => {
    router
      .push(
        `/inventory/privilege/history/group/${item.privilege.privilege_id}/detail/${router.currentRoute.params.ref}`
      )
      .catch(() => { });
  };

  const routeDetail = (item) => {
    router
      .push(
        `/inventory/privilege/history/group/${item.privilege.privilege_id}/detail/${router.currentRoute.params.ref}?tab=import`
      )
      .catch(() => { });
  };

  const routeStockDetail = (item) => {
    router
      .push(
        `/inventory/privilege/history/group/${item.privilege.privilege_id}/detail/${router.currentRoute.params.ref}/stock`
      )
      .catch(() => { });
  };

  const onCloseModalInventoryManage = () => {
    closeModal();
    modalType.reorder = false;
    modalType.addPrivilege = false;
    modalType.transferStock = false;
    modalType.manageStockReward = false;
    modalType.manageStockCouponExternal = false;
    modalType.transferStockForm = false;
  };

  const onSelectPrivilegeToManage = (privilege) => {
    window.$loading(true);
    loading.addPrivilege = true;
    fetchAssignEntryInventory.payload.Inventory_Id =
      router.currentRoute.params.ref;
    fetchAssignEntryInventory.payload.Privilege_Id = privilege.privilege_id;
    store
      .dispatch("api/apiRequest", fetchAssignEntryInventory)
      .then((response) => {
        closeModal();
        setTimeout(() => {
          modalType.addPrivilege = false;
        }, 200);
        setTimeout(() => {
          openManageStockModal(privilege);
        }, 300);
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        window.$loading(false);
        loading.addPrivilege = false;
        fetchPrivilegeInventory(false);
      });
  };

  const onSelectTransferStock = (inventory) => {
    closeModal();
    setTimeout(() => {
      modalType.transferStock = false;
    }, 200);
    setTimeout(() => {
      router
        .replace(
          `${router.currentRoute.path}?transfer=${inventory.inventory_id}`
        )
        .catch(() => { });
      modalType.transferStockForm = true;
      openModal();
    }, 300);
  };

  const onAddPrivilegeToInventory = () => {
    closeModal();
    fetchPrivilegeInventory(false);
    setTimeout(() => {
      modalType.manageStockReward = false;
      modalType.transferStockForm = false;
    }, 300);
  };

  const onClickReorder = () => {
    inventoryManageActionList.reOrder.display = !inventoryManageActionList
      .reOrder.display;
    tableModeReorder.value = !tableModeReorder.value;
    sortableRowOptions.value.disabled = !sortableRowOptions.value.disabled;
  };

  const handleRowChange = (event) => {
    fetchReorderList(
      inventoryManageTable.payload[event.oldDraggableIndex].privilege
        .privilege_id,
      inventoryManageTable.payload[event.oldDraggableIndex].seq,
      inventoryManageTable.payload[event.newDraggableIndex].seq
    );
    inventoryManageTable.payload.splice(
      event.newDraggableIndex,
      0,
      inventoryManageTable.payload.splice(event.oldDraggableIndex, 1)[0]
    );
    keyChange.value++;
  };

  const fetchReorderList = (id, currentPosition, newPosition) => {
    loading.tableOverlay = true;
    fetchReorderPrivilegeList.payload.Privilege_Id = id;
    fetchReorderPrivilegeList.payload.Inventory_Id =
      router.currentRoute.params.ref;
    fetchReorderPrivilegeList.payload.From = currentPosition;
    fetchReorderPrivilegeList.payload.To = newPosition;
    store
      .dispatch("api/apiRequest", fetchReorderPrivilegeList)
      .then((response) => {
        fetchPrivilegeInventory(false);
      })
      .catch((error) => {
        openDefaultErrorModal(error);
        loading.tableOverlay = false;
      });
  };

  const sortableRowOptions = ref({
    chosenClass: "is-selected",
    ghostClass: "sortable-ghost",
    onEnd: handleRowChange,
    disabled: true,
    animation: 300,
    easing: "cubic-bezier(0.22, 1, 0.36, 1)",
  });

  const openReorderModal = (item) => {
    currentIndex.value = item.seq;
    currentIdSelect.value = item.privilege.privilege_id;
    openModal();
  };

  const openManageStockModal = (data) => {
    rewardSelect.value = data;
    const privilegeType = data.type;
    switch (privilegeType) {
      case PRIVILEGE_TYPE.REWARD:
        modalType.manageStockReward = true;
        break;
      case PRIVILEGE_TYPE.CPC:
        modalType.manageStockCouponExternal = true;
        break;
      case PRIVILEGE_TYPE.TOPUP:
        modalType.manageStockReward = true;
        break;
      case PRIVILEGE_TYPE.EXCHANGE:
        modalType.manageStockReward = true;
        break;
      default:
        break;
    }
    openModal();
  };

  const reorderInventoryManage = async (current, newIndex) => {
    fetchReorderList(currentIdSelect.value, currentIndex.value, newIndex);

    keyChange.value++;
    onCloseModalInventoryManage();
  };

  const addPrivilegeToInventory = () => {
    modalType.addPrivilege = true;
    openModal();
  };

  const resolveStatusLabel = (status) => {
    switch (status) {
      case 1:
        return "Active";
      case 2:
        return "Inactive";
      default:
        return "Unknown";
    }
  };

  const resolveStatusClass = (status) => {
    switch (status) {
      case 1:
        return "active-icon";
      case 2:
        return "inActive-icon";
      default:
        return "Unknown";
    }
  };

  const resolveStockModeClass = (stockMode) => {
    switch (stockMode) {
      case 2:
        return "overselling";
      case 3:
        return "restricted";
      default:
        return "";
    }
  };

  const resolveStockModeLabel = (stockMode) => {
    switch (stockMode) {
      case 2:
        return "Overselling";
      case 3:
        return "Restricted";
      default:
        return "-";
    }
  };

  const fetchInventoryDetail = () => {
    if (router.currentRoute.params.ref) {
      window.$loading(true);
      inventoryPrivilegeFormDetail.payload.Inventory_Id =
        router.currentRoute.params.ref;
      store
        .dispatch("api/apiRequest", inventoryPrivilegeFormDetail)
        .then((response) => {
          const { resp } = response.data;
          formInventory.reference = resp.inv_reference;
          formInventory.name = resp.name;
          formInventory.detail = resp.detail;
        })
        .catch((error) => {
          openDefaultErrorModal(error);
        })
        .finally(() => {
          window.$loading(false);
        });
    }
  };

  const fetchPrivilegeInventory = (showLoading = true) => {
    if (showLoading) {
      loading.tableData = true;
    }
    fetchEntryInventoryList.payload.Inventory_Id =
      router.currentRoute.params.ref;
    fetchEntryInventoryList.payload.Page = pagination.currentPage;
    fetchEntryInventoryList.payload.Limit = pagination.perPage;
    fetchEntryInventoryList.payload.Filters = filters;
    fetchEntryInventoryList.payload.Ordering = ordering.value;
    store
      .dispatch("api/apiRequest", fetchEntryInventoryList)
      .then((response) => {
        inventoryManageTable.payload = response.data.payload;
        pagination.rows = response.data.payload.length;
        pagination.totalRows = response.data.filtered_record;
        if (response.data.payload.length > 0 && isDisplayNonePayload.value) {
          isDisplayNonePayload.value = !isDisplayNonePayload.value;
        }
        formStatus.expiredStatus = true
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        loading.tableData = false;
        loading.tableOverlay = false;
      });
  };

  const onEditInventory = () => {
    window.$loading(true);
    loading.formInventory = true;
    inventoryPrivilegeFormEdit.payload.Inventory_Id =
      router.currentRoute.params.ref;
    inventoryPrivilegeFormEdit.payload.Name = formInventory.name;
    inventoryPrivilegeFormEdit.payload.Detail = formInventory.detail;
    store
      .dispatch("api/apiRequest", inventoryPrivilegeFormEdit)
      .then((response) => {
        if ((response.status = "success")) {
          openSuccessModal("ทำรายการสำเร็จ !");
        }
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        window.$loading(false);
        loading.formInventory = false;
      });
  };

  watch(
    pagination,
    () => {
      if (!loading.tableData) {
        fetchPrivilegeInventory();
      }
    },
    { deep: true }
  );

  watch(
    [filters, ordering],
    () => {
      pagination.currentPage = 1;

      fetchPrivilegeInventory();
    },
    { deep: true }
  );

  return {
    PRIVILEGE_TYPE,
    pagination,
    formStatus,
    fields,
    loading,
    statusOption,
    inventoryManageTable,
    inventoryManageActionList,
    sortableRowOptions,
    keyChange,
    tableModeReorder,
    currentIndex,
    modalType,
    rewardSelect,
    formInventory,
    stockModeOption,
    isDisplayNonePayload,
    resolveMappingTableAction,
    resolveStatusLabel,
    resolveStatusClass,
    reorderInventoryManage,
    onClickReorder,
    reorderInventoryManage,
    onCloseModalInventoryManage,
    resolveStockModeClass,
    resolveStockModeLabel,
    addPrivilegeToInventory,
    onSelectPrivilegeToManage,
    onAddPrivilegeToInventory,
    onEditInventory,
    resolveDateWithSeperator,
    onPageChange,
    onFilterEntity,
    onSetValueSearch,
    onSelectFilter,
    fetchInventoryDetail,
    fetchPrivilegeInventory,
    onSelectTransferStock,
    resolveExpiredAlertLabel,
    resolveExpiredAlertClass
  };
}
